import Vue from 'vue';
import Component from 'vue-class-component';

import CatalogReservationConfigManual from 'components/Catalog/CatalogReservationConfigManual';
import CatalogReservationConfigAutomatic from 'components/Catalog/CatalogReservationConfigAutomatic';

import SelectionMenuTabs from 'common/components/SelectionMenuTabs';
import LocationsWithReservationConfig from 'assets/graphql/queries/catalog/LocationsWithReservationConfig.graphql';

const allTabs = [
  { title: 'Reserva online', type: 'online_reservation' },
  { title: 'Reserva Manual', type: 'manual_reservation' },
];

@Component({
  components: {
    SelectionMenuTabs,
    CatalogReservationConfigManual,
    CatalogReservationConfigAutomatic,
  },
  props: {
    code: {
      type: String,
      required: false,
    },
    codeId: {
      type: Number,
      required: false,
    },
    expirationDate: {
      type: String,
      required: false,
    },
    locations: {
      type: Array,
      required: true,
    },
    activity: {
      type: Object,
      required: true,
    },
    categoryColor: {
      type: String,
      required: false,
    },
    codeExpirationDate: {
      type: String,
      required: false,
    },
    isReservationBuy: {
      type: Boolean,
      required: false,
      default: false,
    },
    isComboActivity: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  apollo: {
    locationsWithReservationConfig: {
      query: LocationsWithReservationConfig,
      variables() {
        return {
          activity_id: this.activity.id,
        };
      },
      update(data) {
        return data.locations_with_reservation_configuration;
      },
    },
  },
})
export default class CatalogReservationConfigModalComponent extends Vue {
  tabs = allTabs;
  hasCoverManager = false;
  MIN_WIDTH = 768;
  currentStep = 'select-location-date';

  mounted() {
    if (this.categoryFriendsDay) this.tabs.pop();
  }

  onStepChange(step) {
    this.currentStep = step;
  }

  reservationCreation(status) {
    this.$emit('reservationCreation', status);
  }

  tabsMargin() {
    if (window.innerWidth < this.MIN_WIDTH) {
      return '-16px';
    }
    return '-32px';
  }

  toggleCoverManager(hasCoverManager) {
    this.hasCoverManager = hasCoverManager;
  }

  addToCart(reservationData) {
    this.$emit('addToCart', reservationData);
  }

  get showTabs() {
    if (this.currentStep === 'select-location-date') {
      if (!this.locationsWithOnlineReservation.length) {
        return allTabs.filter(tab => tab.type === 'manual_reservation');
      }
      if (!this.locationsWithManualReservation.length || this.hasCoverManager) {
        return allTabs.filter(tab => tab.type === 'online_reservation');
      }
      return allTabs;
    }
    return allTabs.filter(item => item.type === 'online_reservation');
  }

  /**
   * TODO: this is a workaround because of how SelectionMenuTabs works
   * it should be refactored to use a proper component
   * This getter switches the slot index when there's no online reservation
   */

  get tabsIndex() {
    return this.showTabs[0].type === 'online_reservation' ? [0, 1] : [1, 0];
  }

  get locationsWithOnlineReservation() {
    return this.locationsWithReservationConfig?.filter(
      location =>
        location.has_online_reservation_enabled ||
        location.cover_manager_reservation,
    );
  }
  get locationsWithManualReservation() {
    return this.locationsWithReservationConfig?.filter(
      location =>
        location.manual_reservation && !location.cover_manager_reservation,
    );
  }

  get categoryFriendsDay() {
    return this.activity.category_id === '61';
  }

  get title() {
    return this.isReservationBuy
      ? 'Reservar esta actividad'
      : 'Opciones de reserva';
  }
}
